module.exports = __webpack_public_path__ + "static/media/developerLogo.cc4ba2cf.svg";